import styled from 'styled-components';

export default styled.div`
  display: grid;
  grid-template-columns: 100%;
  align-content: center;
`;
